import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CheckBoxData } from '../../../../shared/models';

@Component({
  selector: 'app-locked-checkbox',
  templateUrl: './locked-checkbox.component.html',
  styleUrls: ['./locked-checkbox.component.scss'],
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LockedCheckboxComponent {
  @Input() data: CheckBoxData;
}
